const RUN_CASE_OPTIONS = {
    RUN_CASE: 'RUN_CASE',
    PREVIEW: 'PREVIEW',
    ON_DEMAND: 'ON_DEMAND',
    LIVE_EVENT: 'LIVE_EVENT',
};

const ON_DEMAND_STEPS = {
    ACCESS_LINKS: 'ACCESS_LINKS',
};

const LIVE_EVENT_STEPS = {
    CHOOSE_EXISTING_ROOM: 'CHOOSE_EXISTING_ROOM',
    CREATE_NEW_ROOM: 'CREATE_NEW_ROOM',
};

const RunCase = {
    key: RUN_CASE_OPTIONS.RUN_CASE,
    header: 'caseWizard.initial.header',
    stepName: 'caseWizard.initial.title',
    descriptionKey: 'caseWizard.description.runCaseWizard',
    options: {
        PREVIEW: RUN_CASE_OPTIONS.PREVIEW,
        ON_DEMAND: RUN_CASE_OPTIONS.ON_DEMAND,
        LIVE_EVENT: RUN_CASE_OPTIONS.LIVE_EVENT,
    },
};

const Preview = {
    key: RUN_CASE_OPTIONS.PREVIEW,
    header: 'caseWizard.preview.header',
    stepName: 'caseWizard.initial.previewTitle',
    descriptionKey: 'caseWizard.initial.previewDescription',
    options: {},
};

const OnDemand = {
    key: RUN_CASE_OPTIONS.ON_DEMAND,
    header: 'caseWizard.onDemand.header',
    stepName: 'caseWizard.initial.onDemandTitle',
    descriptionKey: 'caseWizard.initial.onDemandDescription',
    options: {
        ACCESS_LINKS: {
            key: ON_DEMAND_STEPS.ACCESS_LINKS,
            stepName: 'caseWizard.titles.accessLinks',
            descriptionKey: 'caseWizard.description.accessLinks',
            options: {},
            header: 'caseWizard.onDemand.accessLinks.header',
        },
    },
};

const RoomSelection = {
    key: LIVE_EVENT_STEPS.CHOOSE_EXISTING_ROOM,
    header: 'caseWizard.roomSelection.header',
    stepName: 'caseWizard.titles.roomSelection',
    descriptionKey: 'caseWizard.description.roomSelection',
    options: {},
};

const RoomCreation = {
    key: LIVE_EVENT_STEPS.CREATE_NEW_ROOM,
    header: 'caseWizard.roomCreation.header',
    stepName: 'caseWizard.titles.roomCreation',
    descriptionKey: 'caseWizard.description.roomCreation',
    options: {},
};

const LiveEvent = {
    key: RUN_CASE_OPTIONS.LIVE_EVENT,
    header: 'caseWizard.liveEvent.header',
    stepName: 'caseWizard.initial.liveEventTitle',
    descriptionKey: 'caseWizard.initial.liveEventDescription',
    options: {
        ROOM_SELECTION: RoomSelection,
        ROOM_CREATION: RoomCreation,
    },
};

export type WizardHeaderTranslationKey =
    | 'caseWizard.initial.header'
    | 'caseWizard.preview.header'
    | 'caseWizard.onDemand.header'
    | 'caseWizard.liveEvent.header'
    | 'caseWizard.onDemand.accessLinks.header'
    | 'caseWizard.roomSelection.header'
    | 'caseWizard.roomCreation.header';

export const WIZARD_CONFIG = {
    RUN_CASE: RunCase,
    PREVIEW: Preview,
    ON_DEMAND: OnDemand,
    LIVE_EVENT: LiveEvent,
};

export const INITIAL_WIZARD_STATE: WizardContext = {
    currentStep: WIZARD_CONFIG.RUN_CASE,
    previousStep: undefined,
};

export type WizardStep = (typeof WIZARD_CONFIG)[keyof typeof WIZARD_CONFIG];

export type WizardStepKey = keyof typeof WIZARD_CONFIG;

interface NestedStep {
    key: string;
    header: string;
    stepName: string;
    descriptionKey: string;
    options: Record<string, unknown>;
}

const isNestedStep = (obj: unknown): obj is NestedStep => {
    return typeof obj === 'object' && obj !== null && 'key' in obj && true;
};

export interface WizardContext {
    currentStep: WizardStep;
    previousStep?: WizardStep;
}

export const getStepByKey = (key: string): WizardStep => {
    if (key in WIZARD_CONFIG) {
        return WIZARD_CONFIG[key as WizardStepKey];
    }

    const nestedStep = Object.values(WIZARD_CONFIG)
        .filter((topLevelStep) => (topLevelStep as {options?: Record<string, unknown>}).options)
        .flatMap((topLevelStep) => Object.values((topLevelStep as {options?: Record<string, unknown>}).options || {}))
        .find((nested) => isNestedStep(nested) && nested.key === key);

    if (nestedStep) {
        return nestedStep as WizardStep;
    }

    return WIZARD_CONFIG.RUN_CASE;
};
